/* ==========================================================================
   Lockett Labs Events: shared script (every page on layout/events)
   --------------------------------------------------------------------------
   The header, the way back to the shop, reveal-on-scroll, and a small kit
   the page scripts use: saved shows, countdown wording, calendar files,
   copying, the Discord count, the Eventbrite loader and a DOM builder that
   never takes HTML strings, so text from anywhere stays text.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ---------------------------------------------------------------- kit */

  function el(tag, attrs) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === false) return;
        if (k === 'class') n.className = v;
        else if (k === 'text') n.textContent = v;
        else if (k === 'html') throw new Error('el(): html is not allowed');
        else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.slice(2), v);
        else n.setAttribute(k, v === true ? '' : String(v));
      });
    }
    for (var i = 2; i < arguments.length; i++) {
      var kid = arguments[i];
      if (kid == null || kid === false) continue;
      if (Array.isArray(kid)) { kid.forEach(function (k2) { if (k2 != null && k2 !== false) n.append(k2 instanceof Node ? k2 : document.createTextNode(String(k2))); }); continue; }
      n.append(kid instanceof Node ? kid : document.createTextNode(String(kid)));
    }
    return n;
  }

  function readList(key) {
    try { var v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function writeList(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  /* Saved shows: the same key and event the previous pages used, so a show
     saved before this rebuild is still saved after it. */
  var WATCH_KEY = 'll_tickets_watch';
  var WATCH_EVT = 'll:tickets:change';
  function toggleWatch(handle) {
    var list = readList(WATCH_KEY);
    var at = list.indexOf(handle);
    if (at > -1) list.splice(at, 1); else list.push(handle);
    writeList(WATCH_KEY, list);
    try { document.dispatchEvent(new CustomEvent(WATCH_EVT, { detail: { list: list } })); } catch (e) { /* old browser */ }
    return at === -1;
  }
  function paintBells(root) {
    var list = readList(WATCH_KEY);
    (root || document).querySelectorAll('[data-ev-save]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-ev-save')) > -1 ? 'true' : 'false');
    });
  }

  var toastEl = null;
  var toastTimer = null;
  function toast(msg) {
    toastEl = toastEl || document.querySelector('[data-ev-toast]');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* Wording shared with the diary page and the old show pages. */
  function parseLocal(raw) {
    if (!raw) return null;
    var d = new Date(String(raw).replace(/-/g, '/').replace('T', ' '));
    return isNaN(d.getTime()) ? null : d;
  }
  function countdownText(raw) {
    var when = parseLocal(raw);
    if (!when) return '';
    var mins = Math.round((when.getTime() - Date.now()) / 60000);
    if (mins <= 0) return 'On now';
    var days = Math.floor(mins / 1440);
    if (days > 1) return 'In ' + days + ' days';
    if (days === 1) return 'Tomorrow';
    var hrs = Math.floor(mins / 60);
    return hrs >= 1 ? 'In ' + hrs + (hrs === 1 ? ' hour' : ' hours') : 'In ' + mins + (mins === 1 ? ' minute' : ' minutes');
  }

  /* .ics: same builder and lls- UID prefix as the diary page. */
  function icsEscape(v) {
    return String(v || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  }
  function downloadIcs(d) {
    if (!d.start) { toast('No date set for this show yet'); return; }
    var lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Lockett Labs//Shows//EN', 'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      'UID:lls-' + d.start.slice(0, 8) + '-' + Math.random().toString(36).slice(2, 9) + '@lockett-labs.com',
      'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z',
      'DTSTART:' + d.start,
      'DTEND:' + (d.end || d.start),
      'SUMMARY:' + icsEscape(d.name + ' (Lockett Labs)'),
      'LOCATION:' + icsEscape(d.where),
      'DESCRIPTION:' + icsEscape(d.url),
      'URL:' + icsEscape(d.url),
      'BEGIN:VALARM', 'TRIGGER:-P1D', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsEscape(d.name + ' is tomorrow'), 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ];
    try {
      var url = URL.createObjectURL(new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' }));
      var a = el('a', { href: url, download: (d.name || 'show').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.ics' });
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      toast('Calendar file downloaded');
    } catch (e) { toast('Could not build the calendar file'); }
  }

  function copyText(txt, ok) {
    function fallback() {
      try {
        var ta = el('textarea', { readonly: true, style: 'position:fixed;opacity:0' });
        ta.value = txt;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
        toast(ok || 'Copied');
      } catch (e) { toast('Could not copy that'); }
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(txt).then(function () { toast(ok || 'Copied'); }, fallback);
    else fallback();
  }

  /* Discord's public widget count, cached ten minutes per tab session. */
  function discordOnline(guild) {
    var key = 'll_disc_online_' + guild;
    try {
      var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && Date.now() - hit.t < 600000) return Promise.resolve(hit.n);
    } catch (e) { /* storage blocked */ }
    return fetch('https://discord.com/api/guilds/' + encodeURIComponent(guild) + '/widget.json')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('widget off')); })
      .then(function (d) {
        var n = typeof d.presence_count === 'number' ? d.presence_count : 0;
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), n: n })); } catch (e) { /* ignore */ }
        return n;
      });
  }
  /* Counts fill in when their card nears the screen: most visitors never
     scroll that far, and the widget endpoint is rate limited per IP. */
  function wireDiscordCounts() {
    var boxes = document.querySelectorAll('[data-ev-discord]');
    if (!boxes.length) return;
    function fill(box) {
      var guild = box.getAttribute('data-ev-discord');
      if (!guild) return;
      discordOnline(guild).then(function (n) {
        if (!n) return;
        var out = box.querySelector('[data-ev-online]');
        if (out) out.textContent = n.toLocaleString();
        box.hidden = false;
      }).catch(function () { /* widget switched off; the button still works */ });
    }
    if (!('IntersectionObserver' in window)) { boxes.forEach(fill); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        fill(en.target.__evBox);
      });
    }, { rootMargin: '300px' });
    boxes.forEach(function (box) {
      var card = box.closest('.ev-box, .ev-disc') || box.parentNode;
      card.__evBox = box;
      io.observe(card);
    });
  }

  /* Eventbrite's checkout script, loaded on demand and once. */
  var ebPromise = null;
  function loadEventbrite() {
    if (ebPromise) return ebPromise;
    ebPromise = new Promise(function (resolve, reject) {
      if (window.EBWidgets) { resolve(window.EBWidgets); return; }
      var s = el('script', { src: 'https://www.eventbrite.co.uk/static/widgets/eb_widgets.js', async: true });
      s.onload = function () { window.EBWidgets ? resolve(window.EBWidgets) : reject(new Error('EBWidgets missing')); };
      s.onerror = function () { ebPromise = null; reject(new Error('Eventbrite blocked')); };
      document.head.appendChild(s);
    });
    return ebPromise;
  }

  /* Calls to the events desk. Errors come back as {status, message, fields}. */
  function api(base, path, opts) {
    opts = opts || {};
    var headers = { Accept: 'application/json' };
    if (opts.token) headers.Authorization = 'Bearer ' + opts.token;
    var body = opts.body;
    if (body && !(body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(body);
    }
    return fetch(base.replace(/\/$/, '') + '/' + path, { method: opts.method || (body ? 'POST' : 'GET'), headers: headers, body: body, credentials: 'omit', mode: 'cors' })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (d) {
          if (!r.ok || !d || d.ok === false) {
            var err = new Error((d && d.message) || 'Something went wrong. Please try again.');
            err.status = r.status;
            err.code = d && d.error;
            err.fields = (d && d.fields) || {};
            throw err;
          }
          return d;
        });
      }, function () {
        var err = new Error('We could not reach the events desk. Check your connection and try again.');
        err.status = 0;
        err.fields = {};
        throw err;
      });
  }

  /* Where the events desk is. A developer can point the pages at a desk
     running on their own machine (localStorage ll_ev_api); nothing but a
     localhost address is ever accepted from there. */
  function apiBase(fromPage) {
    try {
      var o = localStorage.getItem('ll_ev_api');
      if (o && /^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?\/[\w\/.-]*$/.test(o)) return o;
    } catch (e) { /* storage blocked */ }
    return fromPage;
  }

  function money(p) {
    var n = Number(p || 0);
    return (n < 0 ? '-£' : '£') + (Math.abs(n) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* The big countdown (hub hero and show hero). One per page, ticking each
     second while the tab is visible. A digit that changes slides in; the
     motion is a one-shot transform, nothing runs at rest. */
  function clock(cd, labelEl) {
    if (!cd) return null;
    var parts = {};
    cd.querySelectorAll('[data-cd]').forEach(function (n) { parts[n.getAttribute('data-cd')] = n; });
    function setDigit(key, val) {
      var box = parts[key];
      if (!box) return;
      var span = box.firstElementChild;
      if (span && span.textContent === val) return;
      box.textContent = '';
      box.append(el('span', { text: val }));
      if (!reduce.matches && span) {
        box.classList.remove('is-tick');
        void box.offsetWidth;
        box.classList.add('is-tick');
      }
    }
    function paint() {
      var start = parseLocal(cd.getAttribute('data-ev-cd'));
      if (!start) return;
      var left = Math.floor((start.getTime() - Date.now()) / 1000);
      if (left <= 0) {
        var end = parseLocal(cd.getAttribute('data-ev-cd-end'));
        if (!end) end = new Date(start.getTime() + 8 * 3600 * 1000);
        cd.classList.add('is-live');
        left = end.getTime() > Date.now() ? Math.floor((end.getTime() - Date.now()) / 1000) : 0;
        if (labelEl && labelEl.textContent !== 'Time left today') labelEl.textContent = 'Time left today';
      }
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      setDigit('d', String(Math.floor(left / 86400)));
      setDigit('h', pad(Math.floor(left / 3600) % 24));
      setDigit('m', pad(Math.floor(left / 60) % 60));
      setDigit('s', pad(left % 60));
    }
    var timer = null;
    function start() { if (!timer) timer = setInterval(paint, 1000); }
    function stop() { clearInterval(timer); timer = null; }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else { paint(); start(); } });
    paint();
    start();
    return { paint: paint, stop: stop };
  }

  window.EV = {
    clock: clock,
    el: el, readList: readList, writeList: writeList, toggleWatch: toggleWatch, paintBells: paintBells,
    WATCH_KEY: WATCH_KEY, WATCH_EVT: WATCH_EVT, toast: toast, countdownText: countdownText, parseLocal: parseLocal,
    downloadIcs: downloadIcs, copyText: copyText, discordOnline: discordOnline, loadEventbrite: loadEventbrite,
    api: api, apiBase: apiBase, money: money, reduce: reduce
  };

  /* ---------------------------------------------------------------- header */

  var header = document.querySelector('[data-evh]');
  var bar = header && header.querySelector('[data-evh-progress]');
  var lastY = window.scrollY;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY;
      if (header) {
        // Tuck after a real scroll down, return on any scroll up.
        var tuck = y > 160 && y > lastY + 4;
        var show = y < lastY - 4 || y < 120;
        if (tuck && !header.classList.contains('is-tucked') && !document.documentElement.classList.contains('ev-locked')) {
          header.classList.add('is-tucked');
          document.body.classList.add('is-tucked');
        } else if (show && header.classList.contains('is-tucked')) {
          header.classList.remove('is-tucked');
          document.body.classList.remove('is-tucked');
        }
      }
      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      }
      lastY = y;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* phone menu */
  var sheet = document.querySelector('[data-evh-sheet]');
  var opener = document.querySelector('[data-evh-open]');
  var lastFocus = null;
  function openSheet() {
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.classList.add('ev-locked');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var first = sheet.querySelector('[data-evh-close]');
    if (first) first.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ev-locked');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    setTimeout(function () { sheet.hidden = true; }, reduce.matches ? 0 : 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (opener) opener.addEventListener('click', openSheet);
  if (sheet) {
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-evh-close]')) closeSheet(); });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = sheet.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }

  /* nav scroll-spy: underline the section on screen */
  var spies = document.querySelectorAll('[data-evh-spy]');
  if (spies.length && 'IntersectionObserver' in window) {
    var map = {};
    spies.forEach(function (a) { map[a.getAttribute('data-evh-spy')] = a; });
    var spyIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var a = map[en.target.id];
        if (!a) return;
        if (en.isIntersecting) {
          spies.forEach(function (x) { x.removeAttribute('aria-current'); });
          a.setAttribute('aria-current', 'true');
        } else if (a.hasAttribute('aria-current')) {
          // scrolled back above every section (the hero): nothing is current
          a.removeAttribute('aria-current');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { var t = document.getElementById(id); if (t) spyIO.observe(t); });
  }

  /* ---------------------------------------------------------------- the way back to the shop */
  /* A visitor who came from the shop goes back to the page they were on. The
     referrer is read once per tab session; only same-site paths outside the
     events pages count, and only the path is kept, never a query string. */
  (function () {
    // On events.lockett-labs.com every same-site page is an events page: the
    // way back is always the shop itself, already the link's address.
    if (location.hostname === 'events.lockett-labs.com') return;
    var KEY = 'll_ev_return';
    // every events page, so none of them is ever taken for "the shop"
    var isEvents = function (p) { return /^\/pages\/(events|event-show|event-traders|event-vendors|vendor-apply|vendor-dashboard)(\/|$)/.test(p); };
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { /* ignore */ }
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        if (r.origin === location.origin && !isEvents(r.pathname) && !/^\/(checkouts|account|cart\/c)/.test(r.pathname)) {
          saved = { path: r.pathname, at: Date.now() };
          sessionStorage.setItem(KEY, JSON.stringify(saved));
        }
      }
    } catch (e) { /* bad referrer */ }
    // a path saved before an events page was added to the list is ignored too
    if (!saved || !saved.path || isEvents(saved.path) || Date.now() - saved.at > 6 * 3600 * 1000) return;
    var p = saved.path;
    var label = 'Back to the shop';
    var pretty = function (h) {
      var t = decodeURIComponent(h || '').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      t = t.charAt(0).toUpperCase() + t.slice(1);
      return t.length > 26 ? t.slice(0, 25).trim() + '…' : t;
    };
    var m;
    if ((m = p.match(/^\/collections\/([^/]+)\/?$/)) && m[1] !== 'all') label = 'Back to ' + pretty(m[1]);
    else if (/^\/(collections\/[^/]+\/)?products\//.test(p)) label = 'Back to your product';
    else if (/^\/search/.test(p)) label = 'Back to your search';
    else if (/^\/cart/.test(p)) label = 'Back to your basket';
    else if (/^\/pages\/watchlist/.test(p)) label = 'Back to your watchlist';
    else if (p === '/' || p === '') label = 'Back to the shop';
    document.querySelectorAll('[data-ev-return]').forEach(function (a) {
      a.setAttribute('href', p);
      var lab = a.querySelector('[data-ev-return-label]');
      if (lab) lab.textContent = label;
      if (a.hasAttribute('title')) a.title = label;
    });
  })();

  /* ---------------------------------------------------------------- reveal and ticker */
  if ('IntersectionObserver' in window) {
    var revIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); revIO.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.ev-reveal').forEach(function (n) { revIO.observe(n); });

    // A ticker that is off screen does not need to move.
    var tickIO = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { en.target.classList.toggle('is-paused', !en.isIntersecting); });
    });
    document.querySelectorAll('.ev-ticker').forEach(function (n) { tickIO.observe(n); });
  } else {
    document.querySelectorAll('.ev-reveal').forEach(function (n) { n.classList.add('is-in'); });
  }

  /* ---------------------------------------------------------------- cookie settings */
  // On events.lockett-labs.com the events site's own banner (snippets/ev-consent)
  // owns this button; Shopify's is never shown there.
  var cookieBtn = document.documentElement.hasAttribute('data-ev-consent') ? null : document.querySelector('[data-ev-cookies]');
  if (cookieBtn) {
    var tries = 0;
    var ready = function () { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; };
    (function check() {
      if (ready()) { cookieBtn.hidden = false; return; }
      if (++tries < 20) setTimeout(check, 750);
    })();
    cookieBtn.addEventListener('click', function () { if (ready()) window.privacyBanner.showPreferences(); });
  }

  wireDiscordCounts();
})();

/* ==========================================================================
   The 2026-10 additions, on window.EV for every events page:
     EV.icon      line and brand icons as SVG elements
     EV.qr        QR codes (byte mode, level M, versions 1 to 15), drawn to
                  a canvas or an SVG; checked against a real decoder
     EV.share     the share sheet: this device, WhatsApp, Facebook, X,
                  Threads, Bluesky, Reddit, Telegram, LinkedIn, email, text,
                  copy link, copy caption, QR code; every link tagged with
                  utm_source so the shop's analytics can tell them apart
     EV.vendor*   trader cards and the trader profile dialog, shared by the
                  hub, the show page and the directory
     EV.tilt      the hero ticket's pointer tilt and foil
     EV.countUp   figures that count up once when they come into view
     EV.url       the events pages' addresses
   ========================================================================== */
(function () {
  'use strict';
  var EV = window.EV;
  if (!EV) return;
  var el = EV.el;
  var NS = 'http://www.w3.org/2000/svg';
  var enc = encodeURIComponent;

  /* ---------------------------------------------------------------- icons */
  var LINE = {
    arrow: 'M5 12h13M13 6l6 6-6 6', back: 'M19 12H6M11 6l-6 6 6 6', check: 'M20 6L9 17l-5-5', x: 'M6 6l12 12M18 6L6 18',
    share: 'M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4',
    link: 'M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1',
    copy: 'M9 9h11v11H9zM5 15H4V4h11v1', mail: 'M3 6h18v12H3zM3 7l9 6 9-6', sms: 'M4 5h16v11H9l-5 4zM8 10h.01M12 10h.01M16 10h.01',
    qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M14 18h2M18 18h2v2M6.5 6.5h1v1h-1zM16.5 6.5h1v1h-1zM6.5 16.5h1v1h-1z',
    down: 'M12 3.5v11M7.6 10.4l4.4 4.4 4.4-4.4M4.5 19.5h15', up: 'M12 20.5v-11M7.6 13.6 12 9.2l4.4 4.4M4.5 4.5h15',
    pin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0116 0zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', cal: 'M3 5h18v16H3zM16 3v4M8 3v4M3 10h18',
    clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5.2l3.2 1.9', search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-3.5-3.5',
    ticket: 'M3 9V7a2 2 0 012-2h14a2 2 0 012 2v2a3 3 0 000 6v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a3 3 0 000-6zM14 5v2M14 11v2M14 17v2',
    stall: 'M4.3 9 5.7 4.9A1.2 1.2 0 0 1 6.85 4h10.3a1.2 1.2 0 0 1 1.15.9L19.7 9M3.1 9h17.8M5.6 9.4V20M18.4 9.4V20M5.6 13.6h12.8',
    users: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21v-1a6 6 0 0 1 12 0v1M16 3.3a4 4 0 0 1 0 7.4M18 14.5a6 6 0 0 1 4 5.5v1',
    dash: 'M4 4h7v9H4zM13 4h7v5h-7zM13 11h7v9h-7zM4 15h7v5H4z', ext: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
    lock: 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4', star: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z',
    crown: 'M3 7l4.5 4L12 4l4.5 7L21 7l-2 11H5zM5 21h14', spark: 'M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8',
    globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.6 9h16.8M3.6 15h16.8M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18',
    chat: 'M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 21 12z', bell: 'M18 16V11a6 6 0 1 0-12 0v5l-2 2h16zM10 21h4',
    doc: 'M14 2.8V8h5.2M19.5 9.6V19a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 19V5A2.5 2.5 0 0 1 7 2.5h6.4zM8.5 13h7M8.5 17h4.5',
    img: 'M3 4.5h18v15H3zM8.6 11.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2zM3.6 17.4l4.6-4.2a2 2 0 0 1 2.7 0l3 2.8 1.7-1.5a2 2 0 0 1 2.6 0l2.2 1.9',
    play: 'M7 4l13 8-13 8z', edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4', megaphone: 'M3 10v4h3l7 5V5L6 10zM17 8.5a5 5 0 0 1 0 7M19.5 6a8.5 8.5 0 0 1 0 12',
    pound: 'M16.5 7.2A3.9 3.9 0 0 0 9.4 9.5c0 2.6 1 4.4.4 7.1-.3 1.4-1.3 2.9-2.8 3.4H17M7.2 13.2h7', info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5h.01',
    out: 'M10 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H10M15 8l4 4-4 4M19 12H9.5', refresh: 'M20 11a8 8 0 0 0-14.5-4.5M4 13a8 8 0 0 0 14.5 4.5M5 3v4h4M19 21v-4h-4',
    clip: 'M20.5 11.5l-8.2 8.2a5.3 5.3 0 01-7.5-7.5l8.6-8.6a3.5 3.5 0 015 5l-8.6 8.6a1.8 1.8 0 01-2.5-2.5l7.9-7.9',
    car: 'M2.6 16.5h18.8v-4.1l-1.7-4.6A2 2 0 0 0 17.8 6.5H6.2a2 2 0 0 0-1.9 1.3l-1.7 4.6zM6 13.6h.01M18 13.6h.01M4.5 16.5V19M19.5 16.5V19',
    box: 'M3 8.2 12 3.5l9 4.7v7.6L12 20.5 3 15.8zM3 8.2 12 13l9-4.8M12 13v7.5', home: 'M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z',
    shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z', poster: 'M5 3h14v18H5zM8 7h8M8 11h8M8 15h5', reddit: 'M12 3.5l1.6 4.4 4.3-1M18 7a1.4 1.4 0 1 0 0-.01M4.6 13.6a7.4 4.9 0 1 0 14.8 0 7.4 4.9 0 1 0-14.8 0M9.3 13h.01M14.7 13h.01M9.4 16.2c1.6 1 3.6 1 5.2 0M5.6 11.2A1.9 1.9 0 1 1 7.8 8.6M18.4 11.2A1.9 1.9 0 1 0 16.2 8.6'
  };
  var SOLID = {
    whatsapp: 'M12.04 2a9.9 9.9 0 0 0-8.53 14.94L2 22l5.2-1.37A9.9 9.9 0 1 0 12.04 2Zm5.8 14.07c-.24.68-1.42 1.3-1.95 1.34-.5.05-.97.23-3.27-.68-2.77-1.09-4.5-3.92-4.64-4.1-.13-.18-1.1-1.47-1.1-2.8 0-1.34.7-2 .95-2.27a1 1 0 0 1 .72-.34h.52c.17 0 .4-.06.62.47.24.55.8 1.92.87 2.06.07.14.11.3.02.48-.1.18-.14.3-.28.46l-.41.48c-.14.14-.28.29-.12.57.16.27.72 1.19 1.55 1.93 1.07.95 1.96 1.25 2.24 1.39.27.14.43.11.6-.07.16-.18.69-.8.87-1.08.18-.27.37-.23.62-.14.25.1 1.6.75 1.87.89.27.14.46.2.52.32.07.11.07.66-.17 1.33Z',
    xlogo: 'M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78L17.75 3Zm-1.08 16.17h1.7L7.4 4.74H5.58l11.09 14.43Z',
    facebook: 'M13.5 21v-7.6h2.6l.4-3h-3V8.5c0-.9.3-1.5 1.5-1.5H16.6V4.3c-.3 0-1.2-.1-2.3-.1-2.3 0-3.8 1.4-3.8 3.9v2.3H8v3h2.5V21h3Z',
    threads: 'M16.9 11.4l-.4-.2c-.2-3-1.9-4.8-4.6-4.8h-.04c-1.6 0-3 .7-3.9 2l1.5 1.03c.66-1 1.7-1.2 2.4-1.2 .9 0 1.6.3 2 .8.33.4.55.96.66 1.67a12 12 0 0 0-2.7-.13c-2.7.16-4.4 1.73-4.3 3.9.06 1.1.6 2.05 1.55 2.67.8.53 1.83.79 2.9.73 1.42-.08 2.53-.62 3.3-1.6.6-.75.97-1.72 1.13-2.94.68.41 1.18.95 1.46 1.6.47 1.1.5 2.92-.98 4.4-1.3 1.3-2.86 1.86-5.2 1.88-2.6-.02-4.57-.86-5.85-2.48C5.4 18 4.82 15.97 4.8 13.4c.02-2.57.6-4.6 1.73-6.08 1.28-1.62 3.25-2.46 5.85-2.48 2.62.02 4.62.86 5.94 2.5.65.8 1.13 1.8 1.45 2.98l1.76-.47c-.38-1.44-.98-2.68-1.8-3.7C18.06 4.06 15.6 3.02 12.4 3h-.02C9.2 3.02 6.76 4.07 5.15 6.12 3.72 7.94 2.98 10.47 2.96 13.4v.02c.02 2.93.76 5.46 2.19 7.28C6.76 22.75 9.2 23.8 12.38 23.8h.02c2.8-.02 4.8-.75 6.43-2.39 2.15-2.15 2.08-4.84 1.37-6.5-.5-1.18-1.48-2.15-2.82-2.77-.16-.08-.32-.15-.48-.21Zm-4.3 4.82c-1.17.07-2.38-.46-2.44-1.6-.04-.85.6-1.79 2.55-1.9.22-.01.44-.02.66-.02.7 0 1.36.07 1.96.2-.22 2.8-1.53 3.25-2.73 3.32Z',
    bluesky: 'M6.3 4.2C8.6 5.9 11 9.4 12 11.3c1-1.9 3.4-5.4 5.7-7.1 1.6-1.2 4.3-2.2 4.3.9 0 .6-.4 5.2-.6 6-.7 2.6-3.4 3.3-5.8 2.9 4.2.7 5.2 3.1 2.9 5.4-4.4 4.5-6.3-1.1-6.8-2.5L12 16.6l-.1.4c-.5 1.4-2.4 7-6.8 2.5-2.3-2.3-1.3-4.7 2.9-5.4-2.4.4-5.1-.3-5.8-2.9-.2-.8-.6-5.4-.6-6 0-3.1 2.7-2.1 4.3-.9Z',
    telegram: 'M21.5 4.3 2.9 11.5c-1.3.5-1.3 1.2-.2 1.6l4.8 1.5 1.8 5.6c.2.6.1.9.8.9.5 0 .7-.2 1-.5l2.3-2.2 4.8 3.5c.9.5 1.5.2 1.7-.8l3.2-15c.3-1.3-.5-1.9-1.4-1.6ZM8.4 14.3l9.9-6.2c.5-.3.9-.1.5.2l-8.4 7.6-.3 3.6-1.7-5.2Z',
    linkedin: 'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.5h4V21H3V9.5Zm6.5 0h3.8v1.6h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.1c0-1.22-.02-2.8-1.7-2.8-1.71 0-1.97 1.33-1.97 2.7V21h-4V9.5Z',
    tiktok: 'M16.6 3c.4 2.1 1.8 3.7 4 3.9v3.2c-1.5 0-2.9-.5-4-1.2v6.2A6.1 6.1 0 1 1 10.5 9v3.3a2.9 2.9 0 1 0 2.9 2.8V3h3.2Z',
    nut: 'M22 12l-5 8.66H7L2 12l5-8.66h10zM12 8.2a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6z'
  };
  function icon(name, cls) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    if (cls) s.setAttribute('class', cls);
    var p = document.createElementNS(NS, 'path');
    if (SOLID[name]) {
      s.setAttribute('fill', 'currentColor');
      p.setAttribute('d', SOLID[name]);
      if (name === 'nut') p.setAttribute('fill-rule', 'evenodd');
    } else if (name === 'instagram') {
      s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '1.9');
      p.setAttribute('d', 'M8 3h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5zM12 16.2a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4zM17.4 6.6h.01');
    } else {
      s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2');
      s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
      p.setAttribute('d', LINE[name] || 'M12 12h.01');
    }
    s.appendChild(p);
    return s;
  }

  /* ---------------------------------------------------------------- QR codes */
  var qrCode = (function () {
    var M = [null, [26, 10, 1, 16, 0, 0], [44, 16, 1, 28, 0, 0], [70, 26, 1, 44, 0, 0], [100, 18, 2, 32, 0, 0], [134, 24, 2, 43, 0, 0],
      [172, 16, 4, 27, 0, 0], [196, 18, 4, 31, 0, 0], [242, 22, 2, 38, 2, 39], [292, 22, 3, 36, 2, 37], [346, 26, 4, 43, 1, 44],
      [404, 30, 1, 50, 4, 51], [466, 22, 6, 36, 2, 37], [532, 22, 8, 37, 1, 38], [581, 24, 4, 40, 5, 41], [655, 24, 5, 41, 5, 42]];
    var ALIGN = [null, [], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50],
      [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70]];
    var EXP = new Array(512), LOG = new Array(256);
    (function () { var x = 1; for (var i = 0; i < 255; i++) { EXP[i] = x; LOG[x] = i; x <<= 1; if (x & 256) x ^= 0x11d; } for (i = 255; i < 512; i++) EXP[i] = EXP[i - 255]; })();
    function mul(a, b) { return a && b ? EXP[LOG[a] + LOG[b]] : 0; }
    function zeros(n) { var a = []; for (var i = 0; i < n; i++) a.push(0); return a; }
    function rsRem(data, n) {
      var g = [1], i, j;
      for (i = 0; i < n; i++) { var ng = zeros(g.length + 1); for (j = 0; j < g.length; j++) { ng[j] ^= g[j]; ng[j + 1] ^= mul(g[j], EXP[i]); } g = ng; }
      var r = data.concat(zeros(n));
      for (i = 0; i < data.length; i++) { var c = r[i]; if (c) for (j = 0; j < g.length; j++) r[i + j] ^= mul(g[j], c); }
      return r.slice(data.length);
    }
    function utf8(s) { var out = [], e = unescape(enc(s)); for (var i = 0; i < e.length; i++) out.push(e.charCodeAt(i)); return out; }
    return function (text) {
      var bytes = utf8(String(text)), v, info, cap, i, j;
      for (v = 1; v <= 15; v++) { info = M[v]; cap = info[2] * info[3] + info[4] * info[5]; if (4 + (v < 10 ? 8 : 16) + bytes.length * 8 <= cap * 8) break; }
      if (v > 15) throw new Error('Too long for a QR code');
      var bits = [];
      var put = function (val, len) { for (var k = len - 1; k >= 0; k--) bits.push((val >>> k) & 1); };
      put(4, 4); put(bytes.length, v < 10 ? 8 : 16);
      bytes.forEach(function (b) { put(b, 8); });
      put(0, Math.min(4, cap * 8 - bits.length));
      while (bits.length % 8) bits.push(0);
      var data = [];
      for (i = 0; i < bits.length; i += 8) { var b = 0; for (j = 0; j < 8; j++) b = (b << 1) | bits[i + j]; data.push(b); }
      for (var pad = 0; data.length < cap; pad++) data.push(pad % 2 ? 0x11 : 0xec);
      var blocks = [], ecs = [], k = 0;
      for (var g = 0; g < 2; g++) {
        var count = g ? info[4] : info[2], len = g ? info[5] : info[3];
        for (var n = 0; n < count; n++) { var blk = data.slice(k, k + len); k += len; blocks.push(blk); ecs.push(rsRem(blk, info[1])); }
      }
      var fin = [], maxLen = 0;
      blocks.forEach(function (x) { maxLen = Math.max(maxLen, x.length); });
      for (i = 0; i < maxLen; i++) blocks.forEach(function (bl) { if (i < bl.length) fin.push(bl[i]); });
      for (i = 0; i < info[1]; i++) ecs.forEach(function (ec) { fin.push(ec[i]); });
      var size = v * 4 + 17, mod = [], fn = [];
      for (i = 0; i < size; i++) { mod.push([]); fn.push([]); for (j = 0; j < size; j++) { mod[i].push(false); fn[i].push(false); } }
      var set = function (x, y, d) { mod[y][x] = d; fn[y][x] = true; };
      var finder = function (cx, cy) {
        for (var dy = -4; dy <= 4; dy++) for (var dx = -4; dx <= 4; dx++) {
          var x = cx + dx, y = cy + dy;
          if (x < 0 || y < 0 || x >= size || y >= size) continue;
          var d = Math.max(Math.abs(dx), Math.abs(dy));
          set(x, y, d !== 2 && d !== 4);
        }
      };
      finder(3, 3); finder(size - 4, 3); finder(3, size - 4);
      for (i = 8; i < size - 8; i++) { set(i, 6, i % 2 === 0); set(6, i, i % 2 === 0); }
      var al = ALIGN[v];
      al.forEach(function (ay) { al.forEach(function (ax) {
        if ((ax === 6 && ay === 6) || (ax === 6 && ay === size - 7) || (ax === size - 7 && ay === 6)) return;
        for (var dy = -2; dy <= 2; dy++) for (var dx = -2; dx <= 2; dx++) set(ax + dx, ay + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
      }); });
      for (i = 0; i < 9; i++) { if (!fn[8][i]) set(i, 8, false); if (!fn[i][8]) set(8, i, false); }
      for (i = 0; i < 8; i++) { set(size - 1 - i, 8, false); set(8, size - 1 - i, false); }
      set(8, size - 8, true);
      if (v >= 7) {
        var rem = v; for (i = 0; i < 12; i++) rem = (rem << 1) ^ ((rem >>> 11) * 0x1f25);
        var vb = (v << 12) | rem;
        for (i = 0; i < 18; i++) { var bit = ((vb >>> i) & 1) === 1, a = size - 11 + (i % 3), bb = Math.floor(i / 3); set(a, bb, bit); set(bb, a, bit); }
      }
      var all = [];
      fin.forEach(function (byte) { for (var q = 7; q >= 0; q--) all.push((byte >>> q) & 1); });
      var idx = 0;
      for (var right = size - 1; right >= 1; right -= 2) {
        if (right === 6) right = 5;
        for (var vert = 0; vert < size; vert++) for (var jx = 0; jx < 2; jx++) {
          var x = right - jx, y = ((right + 1) & 2) === 0 ? size - 1 - vert : vert;
          if (!fn[y][x]) { mod[y][x] = idx < all.length ? all[idx] === 1 : false; idx++; }
        }
      }
      var MASKS = [
        function (x, y) { return (x + y) % 2 === 0; }, function (x, y) { return y % 2 === 0; }, function (x) { return x % 3 === 0; },
        function (x, y) { return (x + y) % 3 === 0; }, function (x, y) { return (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0; },
        function (x, y) { return (x * y) % 2 + (x * y) % 3 === 0; }, function (x, y) { return ((x * y) % 2 + (x * y) % 3) % 2 === 0; },
        function (x, y) { return ((x + y) % 2 + (x * y) % 3) % 2 === 0; }
      ];
      var format = function (mask) { var r = mask << 10; for (var q = 14; q >= 10; q--) if ((r >>> q) & 1) r ^= 0x537 << (q - 10); return ((mask << 10) | r) ^ 0x5412; };
      var apply = function (mask) {
        var m = mod.map(function (row) { return row.slice(); }), yy, xx, q;
        for (yy = 0; yy < size; yy++) for (xx = 0; xx < size; xx++) if (!fn[yy][xx] && MASKS[mask](xx, yy)) m[yy][xx] = !m[yy][xx];
        var f = format(mask);
        for (q = 0; q <= 5; q++) m[q][8] = ((f >>> q) & 1) === 1;
        m[7][8] = ((f >>> 6) & 1) === 1; m[8][8] = ((f >>> 7) & 1) === 1; m[8][7] = ((f >>> 8) & 1) === 1;
        for (q = 9; q < 15; q++) m[8][14 - q] = ((f >>> q) & 1) === 1;
        for (q = 0; q < 8; q++) m[8][size - 1 - q] = ((f >>> q) & 1) === 1;
        for (q = 8; q < 15; q++) m[size - 15 + q][8] = ((f >>> q) & 1) === 1;
        m[size - 8][8] = true;
        return m;
      };
      var penalty = function (m) {
        var p = 0, yy, xx, run, dark = 0;
        for (yy = 0; yy < size; yy++) { run = 1; for (xx = 1; xx < size; xx++) { if (m[yy][xx] === m[yy][xx - 1]) { run++; if (run === 5) p += 3; else if (run > 5) p++; } else run = 1; } }
        for (xx = 0; xx < size; xx++) { run = 1; for (yy = 1; yy < size; yy++) { if (m[yy][xx] === m[yy - 1][xx]) { run++; if (run === 5) p += 3; else if (run > 5) p++; } else run = 1; } }
        for (yy = 0; yy < size - 1; yy++) for (xx = 0; xx < size - 1; xx++) { var c = m[yy][xx]; if (c === m[yy][xx + 1] && c === m[yy + 1][xx] && c === m[yy + 1][xx + 1]) p += 3; }
        for (yy = 0; yy < size; yy++) for (xx = 0; xx < size; xx++) if (m[yy][xx]) dark++;
        return p + Math.floor(Math.abs(dark * 20 - size * size * 10) / (size * size)) * 10;
      };
      var best = null, bestP = Infinity;
      for (var mk = 0; mk < 8; mk++) { var cand = apply(mk), pp = penalty(cand); if (pp < bestP) { bestP = pp; best = cand; } }
      return { size: size, version: v, get: function (x, y) { return x >= 0 && y >= 0 && x < size && y < size && best[y][x]; } };
    };
  })();

  /** Draw a QR code onto a 2D context at x, y, w wide, with a quiet zone of `quiet` modules. */
  function qrDraw(ctx, text, x, y, w, opt) {
    opt = opt || {};
    var c = qrCode(text), quiet = opt.quiet == null ? 2 : opt.quiet, n = c.size + quiet * 2, s = w / n;
    ctx.save();
    if (opt.bg !== false) { ctx.fillStyle = opt.bg || '#fff'; ctx.fillRect(x, y, w, w); }
    ctx.fillStyle = opt.fg || '#0b0711';
    for (var my = 0; my < c.size; my++) for (var mx = 0; mx < c.size; mx++) {
      if (c.get(mx, my)) ctx.fillRect(Math.floor(x + (mx + quiet) * s), Math.floor(y + (my + quiet) * s), Math.ceil(s), Math.ceil(s));
    }
    ctx.restore();
    return c;
  }
  /** A QR code as an SVG element (crisp at any size). */
  function qrSvg(text, opt) {
    opt = opt || {};
    var c = qrCode(text), quiet = opt.quiet == null ? 2 : opt.quiet, n = c.size + quiet * 2;
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 ' + n + ' ' + n);
    s.setAttribute('shape-rendering', 'crispEdges');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', opt.label || 'QR code');
    var bg = document.createElementNS(NS, 'rect');
    bg.setAttribute('width', n); bg.setAttribute('height', n); bg.setAttribute('fill', opt.bg || '#fff');
    s.appendChild(bg);
    var d = '';
    for (var y = 0; y < c.size; y++) for (var x = 0; x < c.size; x++) if (c.get(x, y)) d += 'M' + (x + quiet) + ' ' + (y + quiet) + 'h1v1h-1z';
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', d); p.setAttribute('fill', opt.fg || '#0b0711');
    s.appendChild(p);
    return s;
  }
  function qrPng(text, px, name) {
    var cv = document.createElement('canvas');
    cv.width = cv.height = px || 1024;
    qrDraw(cv.getContext('2d'), text, 0, 0, cv.width, { quiet: 4 });
    cv.toBlob(function (b) { if (b) save(b, (name || 'qr-code') + '.png'); }, 'image/png');
  }
  function save(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = el('a', { href: url, download: name });
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 6000);
  }

  /* ---------------------------------------------------------------- addresses */
  function url(path) {
    try { return new URL(path, location.origin).toString(); } catch (e) { return path; }
  }
  function tag(link, source, medium, campaign) {
    try {
      var u = new URL(link, location.origin);
      u.searchParams.set('utm_source', source);
      u.searchParams.set('utm_medium', medium || 'social');
      if (campaign) u.searchParams.set('utm_campaign', campaign);
      return u.toString();
    } catch (e) { return link; }
  }

  /* ---------------------------------------------------------------- short links
     A show's page, its trader list and its apply page are shared as
     events.lockett-labs.com/<show>, /<show>/traders and /<show>/apply, with
     ?s= saying where (wa, fb, qr...). The Cloudflare worker in
     cloudflare/events-links turns them back into the full, tagged address.
     Set SHORT to '' to share the full addresses instead. */
  var SHORT = 'https://events.lockett-labs.com';
  var SRC = { whatsapp: 'wa', facebook: 'fb', instagram: 'ig', tiktok: 'tt', x: 'x', threads: 'th', bluesky: 'bs', reddit: 'rd', telegram: 'tg', linkedin: 'li', discord: 'dc', email: 'em', sms: 'tx', link: 'cp', caption: 'cap', device: 'dv', qr: 'qr' };
  var HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  var EVENTS_HOST = 'events.lockett-labs.com';
  var NAMED = { traders: 1, apply: 1, trade: 1, dashboard: 1 };
  var NOT_SHOWS = /^(pages|products|collections|cart|account|search|blogs|policies|checkouts|orders|tools|gift_cards|_preview|_diag)$/;
  function shortBase(link) {
    if (!SHORT) return '';
    try {
      var u = new URL(link, location.origin);
      // On events.lockett-labs.com a page's own address is already the short
      // one: /, /<show>, /<show>/traders, /<show>/apply, /traders, /apply.
      if (u.hostname === EVENTS_HOST) {
        var bits = u.pathname.replace(/^\/_preview(?=\/|$)/, '').split('/').filter(Boolean);
        var a = (bits[0] || '').toLowerCase(), b = (bits[1] || '').toLowerCase();
        var tidy = '';
        if (!bits.length) tidy = '/';
        else if (bits.length === 1 && (NAMED[a] || (HANDLE.test(a) && !NOT_SHOWS.test(a)))) tidy = '/' + a;
        else if (bits.length === 2 && HANDLE.test(a) && !NOT_SHOWS.test(a) && !NAMED[a] && (b === 'traders' || b === 'apply')) tidy = '/' + a + '/' + b;
        return tidy ? SHORT + (tidy === '/' ? '/' : tidy) + u.hash : '';
      }
      var p = u.pathname.replace(/\/+$/, '');
      var show = (u.searchParams.get('show') || '').toLowerCase();
      var m = p.match(/^\/pages\/event-show\/([a-z0-9-]+)$/);
      var base = '';
      if (m) base = SHORT + '/' + m[1];
      else if (p === '/pages/events' && !u.searchParams.get('view')) base = SHORT + '/';
      else if ((p === '/pages/event-vendors' || (p === '/pages/events' && u.searchParams.get('view') === 'event-vendors')) && HANDLE.test(show)) base = SHORT + '/' + show + '/traders';
      else if (p === '/pages/vendor-apply' || (p === '/pages/events' && u.searchParams.get('view') === 'vendor-apply')) base = SHORT + (HANDLE.test(show) ? '/' + show + '/apply' : '/apply');
      return base ? base + u.hash : '';
    } catch (e) { return ''; }
  }
  /* ---------------------------------------------------------------- tidy links on events.lockett-labs.com
     The worker (cloudflare/events-links) rewrites the links in each page it
     serves. Links the scripts add afterwards (trader lists, show pickers,
     dashboard cards) are tidied here by the same rules: /pages/event-show/<show>
     becomes /<show>, ?view=event-vendors&show=<show> becomes /<show>/traders,
     and so on. Shop links (products, collections, the basket) are left alone. */
  function tidyPath(u) {
    var p = u.pathname.replace(/\/+$/, '') || '/';
    var q = new URLSearchParams(u.search);
    var view = q.get('view') || '', show = (q.get('show') || '').toLowerCase();
    var ok = HANDLE.test(show) && !NOT_SHOWS.test(show) && !NAMED[show];
    var path = '', used = false, m;
    if (p === '/pages/events') {
      if (!view) path = '/';
      else if (view === 'event-vendors') { path = ok ? '/' + show + '/traders' : '/traders'; used = ok; }
      else if (view === 'vendor-apply') { path = ok ? '/' + show + '/apply' : '/apply'; used = ok; }
      else if (view === 'vendor-dashboard') path = '/dashboard';
      else if (view === 'event-traders') path = '/trade';
    } else if ((m = p.match(/^\/pages\/event-show\/([a-z0-9-]+)$/i))) path = '/' + m[1].toLowerCase();
    else if (p === '/pages/event-vendors') { path = ok ? '/' + show + '/traders' : '/traders'; used = ok; }
    else if (p === '/pages/vendor-apply') { path = ok ? '/' + show + '/apply' : '/apply'; used = ok; }
    else if (p === '/pages/vendor-dashboard') path = '/dashboard';
    else if (p === '/pages/event-traders') path = '/trade';
    if (!path) return '';
    q.delete('view');
    if (used) q.delete('show');
    var qs = q.toString();
    return path + (qs ? '?' + qs : '') + u.hash;
  }
  if (location.hostname === EVENTS_HOST) {
    var tidyBase = /^\/_preview(\/|$)/.test(location.pathname) ? '/_preview' : '';
    var tidyOne = function (a) {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#') return;
      var u;
      try { u = new URL(h, location.href); } catch (e) { return; }
      if (!/^(www\.)?lockett-labs\.com$|^events\.lockett-labs\.com$/.test(u.hostname)) return;
      var t = tidyPath(u);
      if (t) a.setAttribute('href', tidyBase + t);
    };
    var tidyAll = function (root) {
      if (root.matches && root.matches('a[href]')) tidyOne(root);
      if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(tidyOne);
    };
    tidyAll(document);
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          if (m.type === 'attributes') tidyOne(m.target);
          else m.addedNodes.forEach(function (n) { if (n.nodeType === 1) tidyAll(n); });
        });
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
  }

  // base + ?s=<where>, keeping any #part at the end
  function withSource(base, src) {
    var h = base.indexOf('#');
    var hash = h >= 0 ? base.slice(h) : '';
    var b = h >= 0 ? base.slice(0, h) : base;
    var code = SRC[src] || src || '';
    return b + (code ? (b.indexOf('?') >= 0 ? '&' : '?') + 's=' + encodeURIComponent(code) : '') + hash;
  }
  // The short form of an events page link, or '' when it has none.
  function shortLink(link, src) {
    var b = shortBase(link);
    return b ? withSource(b, src) : '';
  }

  /* ---------------------------------------------------------------- the share sheet */
  var touch = window.matchMedia && matchMedia('(pointer: coarse)').matches;
  var NETS = [
    ['whatsapp', 'WhatsApp', function (d) { return 'https://wa.me/?text=' + enc(d.text + '\n' + d.u('whatsapp')); }],
    ['facebook', 'Facebook', function (d) { return 'https://www.facebook.com/sharer/sharer.php?u=' + enc(d.u('facebook')); }],
    ['xlogo', 'X', function (d) { return 'https://x.com/intent/post?text=' + enc(d.text) + '&url=' + enc(d.u('x')) + (d.tags.length ? '&hashtags=' + enc(d.tags.join(',')) : ''); }],
    ['threads', 'Threads', function (d) { return 'https://www.threads.net/intent/post?text=' + enc(d.text + ' ' + d.u('threads')); }],
    ['bluesky', 'Bluesky', function (d) { return 'https://bsky.app/intent/compose?text=' + enc(d.text + ' ' + d.u('bluesky')); }],
    ['reddit', 'Reddit', function (d) { return 'https://www.reddit.com/submit?url=' + enc(d.u('reddit')) + '&title=' + enc(d.title); }],
    ['telegram', 'Telegram', function (d) { return 'https://t.me/share/url?url=' + enc(d.u('telegram')) + '&text=' + enc(d.text); }],
    ['linkedin', 'LinkedIn', function (d) { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(d.u('linkedin')); }],
    ['mail', 'Email', function (d) { return 'mailto:?subject=' + enc(d.title) + '&body=' + enc(d.text + '\n\n' + d.u('email')); }],
    ['sms', 'Text', function (d) { return 'sms:?&body=' + enc(d.text + ' ' + d.u('sms')); }, true]
  ];
  var sheet = null;
  function share(opt) {
    var d = {
      url: url(opt.url || location.href.split('#')[0]),
      title: opt.title || document.title,
      text: opt.text || opt.title || document.title,
      sub: opt.sub || '',
      image: opt.image || '',
      campaign: opt.campaign || '',
      tags: String(opt.hashtags || '').split(/\s+/).map(function (t) { return t.replace(/^#/, ''); }).filter(Boolean).slice(0, 6),
      on: typeof opt.onShare === 'function' ? opt.onShare : function () {}
    };
    // opt.short: a short link of the caller's own (a trader's, say) to share instead
    var base = opt.short || shortBase(d.url);
    d.u = function (src) { return base ? withSource(base, src) : tag(d.url, src, 'social', d.campaign); };
    var caption = d.text + (d.tags.length ? '\n\n' + d.tags.map(function (t) { return '#' + t; }).join(' ') : '') + '\n' + d.u('caption');

    if (sheet) sheet.remove();
    var close = el('button', { type: 'button', class: 'evx-x', 'aria-label': 'Close' }, icon('x'));
    var grid = el('div', { class: 'evx-share__grid', role: 'list' });
    NETS.forEach(function (n) {
      if (n[3] && !touch) return;
      var a = el('a', { class: 'evx-share__net is-' + n[0], href: n[2](d), target: n[0] === 'mail' || n[0] === 'sms' ? null : '_blank', rel: 'noopener', role: 'listitem' },
        el('span', { class: 'evx-share__ic' }, icon(n[0])), el('span', { text: n[1] }));
      a.addEventListener('click', function () { d.on(n[0]); });
      grid.append(a);
    });
    var linkIn = el('input', { class: 'evx-share__url', type: 'text', readonly: true, value: d.u('link'), 'aria-label': 'Link to share' });
    linkIn.addEventListener('focus', function () { linkIn.select(); });
    var copyBtn = el('button', { type: 'button', class: 'ev-btn ev-btn--primary ev-btn--sm' }, icon('copy'), 'Copy link');
    copyBtn.addEventListener('click', function () { EV.copyText(linkIn.value, 'Link copied'); d.on('copy'); });
    var capBtn = el('button', { type: 'button', class: 'evx-chipbtn' }, icon('doc'), 'Copy a caption');
    capBtn.addEventListener('click', function () { EV.copyText(caption, 'Caption copied, with hashtags and the link'); d.on('caption'); });
    var qrBox = el('div', { class: 'evx-share__qr', hidden: true });
    var qrBtn = el('button', { type: 'button', class: 'evx-chipbtn', 'aria-expanded': 'false' }, icon('qr'), 'QR code');
    qrBtn.addEventListener('click', function () {
      if (!qrBox.childNodes.length) {
        var link = d.u('qr').replace('utm_medium=social', 'utm_medium=print');
        var dl = el('button', { type: 'button', class: 'evx-chipbtn' }, icon('down'), 'Download PNG');
        dl.addEventListener('click', function () { qrPng(link, 1200, (d.title || 'show').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-qr'); d.on('qr'); });
        qrBox.append(qrSvg(link, { label: 'QR code for ' + d.title }), el('div', null, el('b', { text: 'Scan to open the page' }), el('p', { class: 'ev-muted', text: 'For posters, flyers and your table. The download is print size.' }), dl));
      }
      qrBox.hidden = !qrBox.hidden;
      qrBtn.setAttribute('aria-expanded', qrBox.hidden ? 'false' : 'true');
    });
    var native = null;
    if (navigator.share) {
      native = el('button', { type: 'button', class: 'ev-btn ev-btn--block evx-share__native' }, icon('share'), 'Share from this device');
      native.addEventListener('click', function () {
        navigator.share({ title: d.title, text: d.text, url: d.u('device') }).then(function () { d.on('device'); }).catch(function () { /* cancelled */ });
      });
    }
    var thumb = d.image ? el('img', { src: d.image, alt: '', loading: 'lazy', decoding: 'async' }) : el('span', { class: 'evx-share__mark' }, icon('nut'));
    sheet = el('dialog', { class: 'evx-share', 'aria-labelledby': 'evx-share-h' },
      el('div', { class: 'evx-share__in' },
        el('header', { class: 'evx-share__head' }, el('div', null, el('span', { class: 'ev-kicker', text: opt.kicker || 'Share' }), el('h2', { id: 'evx-share-h', class: 'ev-display', text: opt.heading || 'Spread the word' })), close),
        el('div', { class: 'evx-share__card' }, el('span', { class: 'evx-share__thumb' }, thumb), el('span', null, el('b', { text: d.title }), d.sub ? el('small', { text: d.sub }) : null, el('small', { class: 'evx-share__host', text: (base || d.url).replace(/^https?:\/\//, '').replace(/[?#].*$/, '').replace(/\/$/, '') }))),
        native,
        grid,
        el('div', { class: 'evx-share__row' }, linkIn, copyBtn),
        el('div', { class: 'evx-share__more' }, capBtn, qrBtn),
        qrBox));
    close.addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    sheet.addEventListener('close', unlockIfLast);
    document.body.appendChild(sheet);
    if (sheet.showModal) { sheet.showModal(); document.documentElement.classList.add('ev-locked'); } else sheet.setAttribute('open', '');
    return sheet;
  }
  /* Any element with data-ev-share opens the sheet for what its attributes say. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ev-share]');
    if (!t) return;
    e.preventDefault();
    share({
      url: t.getAttribute('data-share-url') || location.href.split('#')[0],
      title: t.getAttribute('data-share-title') || document.title,
      text: t.getAttribute('data-share-text') || '',
      sub: t.getAttribute('data-share-sub') || '',
      image: t.getAttribute('data-share-image') || '',
      hashtags: t.getAttribute('data-share-tags') || '',
      campaign: t.getAttribute('data-share-campaign') || '',
      heading: t.getAttribute('data-share-heading') || '',
      kicker: t.getAttribute('data-share-kicker') || ''
    });
  });

  /* ---------------------------------------------------------------- traders */
  /** A trader, from the desk's JSON or from a show page's pipe row:
      initials|name|category|url|logo|sponsor|zone|table|tier|categories|blurb */
  function vendorFrom(src) {
    if (typeof src !== 'string') {
      var t = src.tier || (src.sponsor ? 'partner' : '');
      return {
        name: src.name || '', initials: src.initials || (src.name || '?').slice(0, 2).toUpperCase(), logo: src.logo || '', url: src.url || '',
        website: src.website || '', socials: src.socials || {}, categories: src.categories && src.categories.length ? src.categories : (src.category ? [src.category] : []),
        tier: t, tierName: src.tierName || TIER_NAME[t] || '', blurb: src.blurb || '', zone: src.zone || '', table: src.table || ''
      };
    }
    var p = src.split('|').map(function (s) { return s.trim(); });
    if (p.length < 2) return vendorFrom({ name: src.trim() });
    var flag = (p[5] || '').toLowerCase();
    var tier = (p[8] || '').toLowerCase() || (/^(sponsor|1|true|yes|y)$/.test(flag) ? 'partner' : '');
    var cats = (p[9] || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var withScheme = function (u) { return u && !/^[a-z]+:\/\//i.test(u) ? 'https://' + u : u; };
    var link = withScheme(p[3]);
    var socials = {};
    if (/instagram\.com/i.test(link)) socials.instagram = link; else if (/tiktok\.com/i.test(link)) socials.tiktok = link; else if (/facebook\.com/i.test(link)) socials.facebook = link;
    return {
      name: p[1], initials: p[0] || p[1].slice(0, 2).toUpperCase(), logo: withScheme(p[4]), url: link, website: socials.instagram || socials.tiktok || socials.facebook ? '' : link, socials: socials,
      categories: cats.length ? cats : (p[2] ? [p[2]] : []), tier: tier, tierName: TIER_NAME[tier] || '', blurb: p[10] || '', zone: p[6] || '', table: p[7] || ''
    };
  }
  var TIER_NAME = { headline: 'Headline sponsor', gold: 'Gold sponsor', partner: 'Partner' };
  var TIER_RANK = { headline: 3, gold: 2, partner: 1 };
  function tierRank(v) { return TIER_RANK[v.tier] || 0; }
  // https only, except a desk on this machine during development.
  function safeHttp(u) { return /^https:\/\//i.test(u || '') || /^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?\//.test(u || '') ? u : ''; }
  function vendorLogo(v, cls) {
    var box = el('span', { class: cls || 'evx-vlogo' });
    if (safeHttp(v.logo)) {
      var im = el('img', { src: v.logo, alt: '', loading: 'lazy', decoding: 'async', referrerpolicy: 'no-referrer' });
      im.addEventListener('error', function () { box.textContent = ''; box.append(el('span', { text: v.initials })); });
      box.append(im);
    } else box.append(el('span', { text: v.initials }));
    return box;
  }
  function where(v) { return [v.zone, v.table ? 'Table ' + v.table : ''].filter(Boolean).join(' · '); }
  function vendorCard(v, onOpen) {
    var b = el('button', { type: 'button', class: 'evx-vcard' + (v.tier ? ' is-' + v.tier : ''), 'data-vn': v.name.toLowerCase(), 'aria-label': v.name + (v.tierName ? ', ' + v.tierName : '') + (v.categories[0] ? ', ' + v.categories[0] : '') },
      vendorLogo(v),
      el('span', { class: 'evx-vcard__tx' }, el('b', { text: v.name }), v.categories[0] ? el('span', { text: v.categories.slice(0, 2).join(' · ') }) : null, where(v) ? el('span', { class: 'evx-vcard__where' }, icon('pin'), where(v)) : null),
      v.tier ? el('span', { class: 'evx-tier is-' + v.tier }, icon(v.tier === 'headline' ? 'crown' : 'star'), v.tierName) : null);
    b.addEventListener('click', function () { (onOpen || vendorDialog)(v); });
    return b;
  }
  /** A sponsor: headline (wide, with their line), gold (a card), partner (a tile). */
  function sponsorCard(v, onOpen) {
    var b = el('button', { type: 'button', class: 'evx-sponsor is-' + v.tier },
      vendorLogo(v),
      el('span', { class: 'evx-sponsor__tx' },
        el('span', { class: 'evx-tier is-' + v.tier }, icon(v.tier === 'headline' ? 'crown' : 'star'), v.tierName),
        el('b', { text: v.name }),
        v.blurb && v.tier !== 'partner' ? el('span', { class: 'evx-sponsor__blurb', text: v.blurb }) : (v.categories[0] ? el('span', { text: v.categories[0] }) : null)));
    b.addEventListener('click', function () { (onOpen || vendorDialog)(v); });
    return b;
  }
  /** The trader's profile: logo, level, their line, what they sell, where they are, their links. */
  var vdlg = null;
  function vendorDialog(v, ctx) {
    ctx = ctx || {};
    if (vdlg) vdlg.remove();
    var links = el('div', { class: 'evx-vprof__links' });
    var add = function (href, ic, label) { if (safeHttp(href)) links.append(el('a', { class: 'evx-chipbtn', href: href, target: '_blank', rel: 'noopener nofollow' }, icon(ic), label)); };
    add(v.website, 'globe', 'Website');
    add(v.socials.instagram, 'instagram', 'Instagram');
    add(v.socials.tiktok, 'tiktok', 'TikTok');
    add(v.socials.facebook, 'facebook', 'Facebook');
    if (!links.childNodes.length) add(v.url, 'ext', 'Visit');
    var close = el('button', { type: 'button', class: 'evx-x', 'aria-label': 'Close' }, icon('x'));
    var cats = el('div', { class: 'evx-vprof__cats' });
    v.categories.forEach(function (c) { cats.append(el('span', { class: 'ev-tag', text: c })); });
    var shareBtn = el('button', { type: 'button', class: 'evx-chipbtn' }, icon('share'), 'Share');
    shareBtn.addEventListener('click', function () {
      share({ url: ctx.url || location.href.split('#')[0], title: v.name + (ctx.event ? ' at ' + ctx.event : ''), text: v.name + ' is trading' + (ctx.event ? ' at ' + ctx.event : '') + '. Come and say hi.', sub: where(v), image: safeHttp(v.logo), campaign: ctx.campaign || 'trader', heading: 'Share this trader' });
    });
    vdlg = el('dialog', { class: 'evx-vprof' + (v.tier ? ' is-' + v.tier : ''), 'aria-labelledby': 'evx-vprof-h' },
      el('div', { class: 'evx-vprof__in' },
        el('div', { class: 'evx-vprof__top' }, vendorLogo(v, 'evx-vlogo evx-vlogo--xl'), close),
        v.tier ? el('span', { class: 'evx-tier is-' + v.tier }, icon(v.tier === 'headline' ? 'crown' : 'star'), v.tierName) : null,
        el('h2', { class: 'ev-display', id: 'evx-vprof-h', text: v.name }),
        v.blurb ? el('p', { class: 'evx-vprof__blurb', text: v.blurb }) : null,
        cats.childNodes.length ? cats : null,
        where(v) ? el('p', { class: 'evx-vprof__where' }, icon('pin'), el('span', { text: 'Find them: ' + where(v) })) : null,
        el('div', { class: 'evx-vprof__acts' }, links, shareBtn)));
    close.addEventListener('click', function () { vdlg.close(); });
    vdlg.addEventListener('click', function (e) { if (e.target === vdlg) vdlg.close(); });
    vdlg.addEventListener('close', unlockIfLast);
    document.body.appendChild(vdlg);
    if (vdlg.showModal) { vdlg.showModal(); document.documentElement.classList.add('ev-locked'); } else vdlg.setAttribute('open', '');
  }
  /** Sponsors first, by level, then A to Z. */
  function vendorSort(list) {
    return list.slice().sort(function (a, b) { return tierRank(b) - tierRank(a) || a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
  }
  /* The page stays locked while any of these sheets is still open: a trader's
     profile opened from the list closes back to the list, not the page. */
  function unlockIfLast() {
    if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('ev-locked');
  }

  /** Every trader at a show in a sheet over the page: search, what they sell,
      sponsors first; each opens their profile. ctx: event, url (to share a
      trader), campaign, pageUrl (the Who's trading page), date. */
  var adlg = null;
  function allTraders(list, ctx) {
    ctx = ctx || {};
    if (adlg) adlg.remove();
    var all = vendorSort((list || []).filter(function (v) { return v && v.name; }));
    var sponsors = all.filter(function (v) { return v.tier; }).length;
    var q = '', cat = '';
    var cats = {};
    all.forEach(function (v) { v.categories.forEach(function (c) { cats[c] = (cats[c] || 0) + 1; }); });
    var keys = Object.keys(cats).sort(function (a, b) { return cats[b] - cats[a] || a.localeCompare(b); });
    var close = el('button', { type: 'button', class: 'evx-x', 'aria-label': 'Close' }, icon('x'));
    var input = el('input', { type: 'search', placeholder: 'Search by name or what they sell', autocomplete: 'off', enterkeyhint: 'search', 'aria-label': 'Search traders' });
    var chips = el('div', { class: 'evx-all__chips', role: 'group', 'aria-label': 'What they sell' });
    var grid = el('div', { class: 'evx-vgrid evx-all__grid' });
    var count = el('p', { class: 'evx-all__count', 'aria-live': 'polite' });
    var none = el('p', { class: 'evx-all__none' }, icon('search'), el('span', { text: 'Nobody matches that. Try another word, or clear the category.' }));
    function open(v) { vendorDialog(v, { event: ctx.event, url: ctx.url, campaign: ctx.campaign }); }
    function paintChips() {
      chips.textContent = '';
      if (keys.length < 2) return;
      [['', 'Everything', 0]].concat(keys.map(function (k) { return [k, k, cats[k]]; })).forEach(function (c) {
        var b = el('button', { type: 'button', class: 'ev-chip', 'aria-pressed': cat === c[0] ? 'true' : 'false' }, c[1], c[2] ? el('small', { text: ' ' + c[2] }) : null);
        b.addEventListener('click', function () { cat = cat === c[0] ? '' : c[0]; paintChips(); paint(); });
        chips.append(b);
      });
    }
    function paint() {
      var s = q.trim().toLowerCase();
      var shown = all.filter(function (v) {
        if (cat && v.categories.indexOf(cat) === -1) return false;
        return !s || (v.name + ' ' + v.categories.join(' ') + ' ' + v.blurb).toLowerCase().indexOf(s) > -1;
      });
      grid.textContent = '';
      shown.forEach(function (v) { grid.append(vendorCard(v, open)); });
      count.textContent = s || cat
        ? shown.length + ' of ' + all.length + ' traders'
        : all.length + (all.length === 1 ? ' trader' : ' traders') + (sponsors ? ', ' + sponsors + (sponsors === 1 ? ' sponsor' : ' sponsors') : '');
      none.hidden = !!shown.length;
    }
    var qt = 0;
    input.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { q = input.value; paint(); }, 100); });
    var foot = el('footer', { class: 'evx-all__foot' });
    var shareBtn = el('button', { type: 'button', class: 'ev-btn ev-btn--sm' }, icon('share'), 'Share the list');
    shareBtn.addEventListener('click', function () {
      share({ url: ctx.pageUrl || ctx.url || location.href.split('#')[0], title: "Who's trading" + (ctx.event ? ' at ' + ctx.event : ''), text: 'The traders' + (ctx.event ? ' at ' + ctx.event : '') + (ctx.date ? ', ' + ctx.date : '') + '. Plan your day:', sub: ctx.date || '', campaign: ctx.campaign || 'traders', heading: 'Share the trader list' });
    });
    foot.append(shareBtn);
    if (ctx.pageUrl) foot.append(el('a', { class: 'ev-btn ev-btn--sm ev-btn--ghost', href: ctx.pageUrl }, 'Open the trader page', icon('arrow', 'ev-arr')));
    adlg = el('dialog', { class: 'evx-all', 'aria-labelledby': 'evx-all-h' },
      el('div', { class: 'evx-all__in' },
        el('div', { class: 'evx-all__top' },
          el('header', { class: 'evx-all__head' },
            el('div', null, el('span', { class: 'ev-kicker is-gold', text: "Who's trading" }), el('h2', { class: 'ev-display', id: 'evx-all-h', text: ctx.event ? 'Every trader at ' + ctx.event : 'Every trader' }), count),
            close),
          el('label', { class: 'ev-search evx-all__search' }, icon('search'), input),
          chips),
        el('div', { class: 'evx-all__body' }, grid, none),
        foot));
    paintChips();
    paint();
    close.addEventListener('click', function () { adlg.close(); });
    adlg.addEventListener('click', function (e) { if (e.target === adlg) adlg.close(); });
    adlg.addEventListener('close', unlockIfLast);
    document.body.appendChild(adlg);
    if (adlg.showModal) { adlg.showModal(); document.documentElement.classList.add('ev-locked'); } else adlg.setAttribute('open', '');
    // a phone keyboard would cover half the list, so focus the list's close, not the search
    if (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) input.focus(); else close.focus();
    return adlg;
  }

  /* ---------------------------------------------------------------- motion */
  /** Tilt toward the pointer, with the foil following it. Desktop pointers only, never with reduced motion. */
  function tilt(node, max) {
    if (!node || EV.reduce.matches || !(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    max = max || 7;
    var raf = 0, rect = null;
    node.addEventListener('pointerenter', function () { rect = node.getBoundingClientRect(); node.classList.add('is-tilting'); });
    node.addEventListener('pointermove', function (e) {
      if (!rect) rect = node.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width, y = (e.clientY - rect.top) / rect.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        node.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        node.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        node.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        node.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
    });
    node.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      rect = null;
      node.classList.remove('is-tilting');
      node.style.setProperty('--rx', '0deg');
      node.style.setProperty('--ry', '0deg');
    });
  }
  /** Count a figure up once, the first time it comes into view. */
  function countUp(node, to, fmt) {
    fmt = fmt || function (n) { return Math.round(n).toLocaleString('en-GB'); };
    if (!node) return;
    if (EV.reduce.matches || !('IntersectionObserver' in window)) { node.textContent = fmt(to); return; }
    var go = function () {
      var t0 = performance.now(), dur = Math.min(1400, 500 + to * 12);
      (function step(t) {
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        node.textContent = fmt(to * e);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    };
    var io = new IntersectionObserver(function (ents) { if (ents[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: 0.4 });
    io.observe(node);
  }

  /* ---------------------------------------------------------------- go */
  EV.icon = icon;
  EV.qr = qrCode;
  EV.qrDraw = qrDraw;
  EV.qrSvg = qrSvg;
  EV.qrPng = qrPng;
  EV.save = save;
  EV.tag = tag;
  EV.SHORT = SHORT;
  EV.shortLink = shortLink;
  EV.withSource = withSource;
  EV.url = url;
  EV.share = share;
  EV.vendorFrom = vendorFrom;
  EV.vendorCard = vendorCard;
  EV.sponsorCard = sponsorCard;
  EV.vendorDialog = vendorDialog;
  EV.vendorLogo = vendorLogo;
  EV.vendorSort = vendorSort;
  EV.allTraders = allTraders;
  EV.TIER_NAME = TIER_NAME;
  EV.tilt = tilt;
  EV.countUp = countUp;
  document.querySelectorAll('[data-ev-tilt]').forEach(function (n) { tilt(n, Number(n.getAttribute('data-ev-tilt')) || 7); });
})();
